import type { ReactNode } from "react";

import styles from "./Record.module.css";

/**
 * What a toggle unfolds (design 2026-10-24 §6.2, §8.7): grid rows from 0fr
 * to 1fr, the one named exception to „transform and opacity only" besides
 * the theme's reveal. Folded it is `inert` and out of the accessible tree —
 * no Tab stop lands inside it, no name of it is read — until it is open.
 */
export function Fold({
  id,
  open,
  className,
  children,
}: {
  id: string;
  open: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      id={id}
      className={className !== undefined ? `${styles.fold} ${className}` : styles.fold}
      data-open={open ? "" : undefined}
      inert={!open}
      aria-hidden={open ? undefined : true}
    >
      <div className={styles.foldInner}>{children}</div>
    </div>
  );
}
